import { GetAllMailBodyTemplateDto } from "../../dtos/mailTemplate";
import { get } from "../../utils/BaseService";

export async function getAllMailTemplates(dispatch: any):Promise<GetAllMailBodyTemplateDto[]> {
  return await get(dispatch, '/mailBodyTemplate/getAllTemplates', null);
}